import React from 'react'
import { Query } from 'react-apollo'
import { GET_IMAGES } from 'operations/Object'
// import NoData from 'components/NoData'
import SVG from 'components/SVG'

import ImageGrid from 'components/ImageGrid'

import './images.css'
import { EditorContext } from '../../providers/Editor';

export function Images () {

    return(
        <Query query={ GET_IMAGES } >
            {({ loading, error, data: { images } }) => {
                if (loading) return 'Loading...';
                if (error) return `Error! ${error.message}`;

                // console.log('RERENDER', images)

                const imageGrid = !images.length ? (
                    // <NoData>Looks like you haven't uploaded any images yet.<br/>Let's get started!</NoData>
                    <SVG svg='image upload'>
                        Drop your first image here
                    </SVG>
                ) : (
                    <EditorContext.Consumer>
                        {({ toggleEditor }) => (
                            <ImageGrid images={images} options={{
                                scroller: window, 
                                gutterSize: 6, 
                                aspectRatios: { sm: 3, md: 6, lg: 8, xl: 10 }
                            }} onClick={(e) => toggleEditor(e)} />
                        )}                        
                    </EditorContext.Consumer>
                )
                
                return (
                    <React.Fragment>
                        { imageGrid }
                    </React.Fragment>                    
                );
            }}
        </Query>
    )

}

// class ImageGrid extends React.Component {

//     constructor(props) {
//         super(props)
//         this.state = {
//             clientWidth: 0,
//             clientHeight: 0,
//             imageRows: null,
//             gridGap: 5,
//             rowHeight: 200,
//             selected: null
//         }

//         this.handleChange = this.handleChange.bind(this)
//         this.handleSelect = this.handleSelect.bind(this)
//     }

//     handleChange({ target: { value } }) {
//         const rows = imageRows(this.props.images, this.state.rowHeight, this.state.clientWidth, this.state.gridGap)
//         this.setState({
//             rowHeight: +value,
//             imageRows: rows
//         })
//     }

//     handleSelect(image) {
//         this.setState({
//             selected: image
//         })
//     }

//     componentDidMount() {
//         const { clientHeight, clientWidth } = this.refs.imageGrid
//         const rows = imageRows(this.props.images, this.state.rowHeight, clientWidth, this.state.gridGap)
//         this.setState({
//             clientHeight,
//             clientWidth,
//             imageRows: rows
//         })
//     }

//     componentWillUnmount() {
//         this.setState({
//             clientWidth: 0,
//             clientHeight: 0,
//             imageRows: null,
//             gridGap: 5,
//             rowHeight: 200,
//             selected: null
//         })
//     }

//     componentDidUpdate(prevProps, prevState) {
//         if (prevProps !== this.props) {
//             const { clientWidth } = this.refs.imageGrid
//             const rows = imageRows(this.props.images, this.state.rowHeight, clientWidth, this.state.gridGap)
//             this.setState({
//                 imageRows: rows
//             })
//         }
//     }

//     render() {

//         const { imageRows, gridGap, selected } = this.state

//         return(
//             <div ref="imageGrid" style={{ minHeight: '1200px' }}>
//                 {
//                     imageRows ? (

//                         <React.Fragment>
//                             {
//                                 imageRows.map((row, i) => (
//                                     <div className='imageRow' key={i}>
//                                         {
//                                             row.map(({ image, height, width }, i) => {
//                                                 // const url = `http://localhost:3001/${ image.id }/${ image.originalName }?scale.height=${ Math.round(height) }`
//                                                 const url = `https://cdn.tueri.io/${ image.id }/${ image.originalName }?scale.height=${ Math.round(height) }`
//                                                 // const url = `http://render.default.174.138.62.70.xip.io/${ image.id }/${ image.originalName }?scale.height=${ Math.round(height) }`
//                                                 const rightMargin = row.length !== i + 1 ? gridGap : 0
//                                                 return (
//                                                     <React.Fragment key={i}>
//                                                         {
//                                                             selected === image.id ? <Editor onClose={() => { this.setState({ selected: null }) }} object={ selected } image={ image } /> : null
//                                                         }
//                                                         <div className='tueri__imageWrapper' style={{ width: width + 'px', height: height + 'px', marginBottom: gridGap + 'px', marginRight: rightMargin + 'px' }}>
//                                                             {/* <img className='tueri__blurUp' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsTAAALEwEAmpwYAAAER0lEQVQ4y5VUaVCTVxTN2HHojJ1ORxw7rTh1+geNLaWKLHYq0WKFuuAIAbWyhEUEKpsssohYKUVbbbGiIktkBxVFFEQorQtaqYYkKFLMDpWaGJoEQmjI973TR9Su0x89M3fevHnnnnnn3vseR6/Xz+BQDA0NhRp+NfRPjJt7zeNmsWF0VDxmMolNxukwisfHxsXmpyGi+wcjIyNld+7enTmdq1QqOX8AgH2lpJ6zl5oRl5WCnAP7UXK2AQeKDqOsvATltVXYXbAX6Z9mITVvNwq+OoAn+ifQqDVLp3NVKtUMzj9hMU9cKzp5FJy5L07NnufIro/4mJ2z0IldsyWQ3ZyYwr626HXWlbeE9eSvZjw3rCRKldKqfaxd9p+CJuPYdWHlCbh4uzMLXLgkIGgNFnm9jbjcfThcVotVfH+EZCQhYGcEeXeFG1QqpU2r1bn9S/C55UnL5I2Cg/lwW7eK4X8SjSU+7ojfk4PmtmuoamjB2fZrSC/6GuFpccQ3cC1kcplNrx/1mM4dHh6eqdFongpG5SbaV1r0G03NZ8B97x2Gv2ML3Hy9setgMTpvinHxylV8f1OE+Ox0vLXak7jSGz4cHLSp1GruX11KpJI/N0aD8Xrz+UY4uzszLu4LSVBEMAmMSyKCzF2oOtdEzrR3Ie9QIWJT4klCWgJ0Oh0DhqRSh+to5/3uiO46cJ61/N7gw8Fb6qHhMYVCjsqGavLKfEdmweL5Nq63KzuH64S65ibS2nEZFY01aO68gvbLraSl7SIqT9eiovYUlBoVDAZDgF2QHxOGTSGbkfdlIUKTY0nj+SZcoOTyaiHqztXjuLCU/UkmgyAhGrOcZsPDj0c8/D7ABkEocfbiMm8sXzxZVisEWAjsgkt8lsPLj2flRwlY7qpltAE1ZmqjYcxo+oYO+m3LhAV6nY5NzEymdV1JeGvfR1p+IYpKa5D4eT7xEwTbhDV2wVC74PptGxGZuoupu9BBPisuwrdXuyZ/FEv6RRJJOe2ccNxsxqh+lGTszSTeAT7wjwpHTUsX6RE9ICfqG+Hi42Grqq8GredTwQ83rYa7H4/xjw5DRv4+EpkYC35MBJpaW6DT6kbVavUIHeCp7Lx0zH3TkSxd6UlWBPkjLC0JviGbicOrs6aOlxylphBhF9yetB3+WwOswdHbmEMnS9iEzFQmNGknjpQe08DKOj8b3NK2jkvIyc+1Zu3PZrMKcseyCvdbik9VsFn79lhv3boBi+U33+eDDZlMLlIoFOctFgtCY8OtvKAN+OLIYRU9cngwMOBGP44exsaAsGSajonxidP0E5HgGYxGI305qjq5XO7EoUJxcrlsK038SKlQlHV814lj1ULFD3dumyj3ZVGvaAElJvf390dKpdIoaZ80mkaYtK9PcO/+/WiJVBo5MDCwQyaTRXV3d7/0t/fcKxbP0/7yuFT/WLvn0c+PDgpiol7g/E/8DgQm2obPMGiUAAAAAElFTkSuQmCC" alt=''/> */}
//                                                             <picture>
//                                                                 <img style={{ height: height + 'px' }} onClick={ () => this.handleSelect(image.id) } src={ url } alt=''/>
//                                                             </picture>
//                                                         </div>
//                                                     </React.Fragment>
//                                                 )
//                                             })
//                                         }
//                                     </div>
//                                 ))
//                             }

//                         </React.Fragment>

//                     ) : null
//                 }

//             </div>
//         )

//     }

// }

// function imageRows(images, rowHeight, containerWidth, gridGap) {

//     let widthCounter = 0;
//     let rowNum = 0
//     const rows = [{ rowWidth: 0, images: [] }]

//     function getWidthFromHeight(width, height, rowHeight) {
//         const aspectRatio = width / height
//         const calculatedWidth = rowHeight * aspectRatio
//         return calculatedWidth
//     }

//     Object.keys(images).map(i => {
//         let image = images[i]

//         const width = getWidthFromHeight(image.metadata.width, image.metadata.height, rowHeight)

//         if (widthCounter + width >= containerWidth) {
//             rows[rowNum].rowWidth = widthCounter
//             rowNum++
//             widthCounter = 0
//             rows.push({ rowWidth: 0, images: [] })
//         }

//         rows[rowNum].images.push({ image, width, height: rowHeight })
//         return widthCounter += width

//     })

//     function autoFitImages(imageRow, containerWidth, gridGap) {

//         const images = []

//         if (imageRow.rowWidth > 0) {

//             const gridGapSize = gridGap * (imageRow.images.length - 1)

//             const widthDifference = containerWidth - gridGapSize - imageRow.rowWidth
            
//             imageRow.images.map(image => {

//                 const percent = image.width / ( containerWidth - widthDifference )
//                 const scaleAmount = widthDifference * percent
//                 const aspectRatio = image.width / image.height
//                 const width = image.width + scaleAmount
//                 const height = width / aspectRatio

//                 return images.push({ image: image.image, width, height })

//             })

//         }

//         else {
//             imageRow.images.map(image => {

//                 return images.push({ image: image.image, width: image.width, height: image.height })

//             })
//         }
//         return images

//     }

//     const autoFitRows = []
//     rows.map((imageRow, i) => {

//         return autoFitRows.push(autoFitImages(imageRow, containerWidth, gridGap))

//     })

//     return autoFitRows
    
// }




// WEBPACK FOOTER //
// ./src/containers/Images/index.js